module.exports = __webpack_public_path__ + "img/call_talent3.16a0ae4c.jpeg";